import { IconHeading3Outline18 as Heading3 } from "nucleo-ui-outline-18"

import { ShortcutSymbols } from "@productlane/lib/src/shortcut-symbols"

import type { SlashCommandDefinition } from "../types"
import { iconClassName } from "../constants"

export const heading3Command: SlashCommandDefinition = {
	key: "heading3",
	title: "Heading 3",
	icon: <Heading3 strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor
			.chain()
			.focus()
			.deleteRange(range)
			.setNode("heading", { level: 3 })
			.run()
	},
	group: "headings",
	shortcutIcons: [
		ShortcutSymbols.CTRL,
		ShortcutSymbols.SHIFT,
		ShortcutSymbols[3],
	],
}
